import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import '../App.css';
import 'rsuite/DatePicker/styles/index.css';
import Input from './Input';
import InputPhone from './InputPhone';
import { aplicarMascaraCpfCnpj } from '../utils/MaskUtils';
import { showNotification } from '../utils/NotificationUtils';
import Button from '@mui/material/Button';
import BackIcon from '@mui/icons-material/Reply';
import { request } from '../utils/ApiUtils';
import { getUserLogged } from '../utils/TokenUtils';
import CheckboxComConfirmacao from './ModalConfirmacao';

function ClienteForm() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [cliente, setCliente] = useState({ativo: true})
    const [showInactiveModal, setShowInactiveModal] = useState(false)
    const [error, setError] = useState({ })
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        loadCliente();
    }, [id]);

    const loadCliente = async () => {
        if (id) {
            request(`clientes/${id}`, {
                type: 'GET',
                callback: (data) => setCliente(data),
                callbackError: (responseData, message) => showNotification(message || 'Ocorreu um erro inesperado, tente novamente ou contate o suporte.', 'error')
            })
    
        } else {
            setCliente({ativo: true});
        }
    }

    const salvarCliente = async () => {
        cliente.usuarioUltimaAlteracao = getUserLogged();
        setIsSaving(true);
        setCliente({...cliente});

        const method = cliente.id ? "PUT" : "POST";
        const url = cliente.id ? `clientes/${cliente.id}` : "clientes";

        request(url, {
            type: method,
            body: JSON.stringify(cliente),
            callback: (data) => {
                showNotification('Cliente salvo', 'success');
                setCliente(Object.assign({}, data));
                if (!id) navigate(`/clientes/cadastro/${data.id}`);
            },
            callbackError: (responseData, message) => {
                const errorsEmpty = !responseData?.errors || Object.keys(responseData?.errors).length === 0;
                
                if (!errorsEmpty) {
                    setError(responseData.errors);
                }

                if (responseData?.handledError) {
                    if (!errorsEmpty) {
                        Object.entries(responseData?.errors).forEach(([key, value]) => {
            
                            showNotification(value, 'error', 5000);
                        });
                    } 
                    else if (responseData?.error) {
                       showNotification(responseData.error, 'error', 5000);
                    }
                } else {
                    showNotification('Não foi possível salvar o cliente, revise os dados informados.', 'error');
                }
            },
            finally: () => {
                setIsSaving(false);
            }
        })
    };

    const handleInputChange = async (campo, valor) => {
        error[campo] = undefined;
        setError(error)

        setCliente(prevCliente => {
            const keys = campo.split("."); // Divide o caminho do campo (ex: ['endereco', 'rua'])
            const newCliente = { ...prevCliente }; // Clona o objeto principal
    
            // Percorre as chaves e recria os objetos internos
            keys.reduce((obj, key, index) => {
                if (index === keys.length - 1) {
                    obj[key] = valor; // Define o novo valor no campo correto
                } else {
                    obj[key] = { ...obj[key] }; // Clona o nível atual para manter a imutabilidade
                }
                return obj[key]; // Retorna o objeto aninhado para a próxima iteração
            }, newCliente);
    
            return newCliente; // Retorna o novo estado atualizado
        });
    };

    const handleCEP = async (valor) => {
        if (valor?.length == 8) {
    
                fetch(`https://viacep.com.br/ws/${valor}/json/`)
                    .then(response => response.json())
                    .then(data => {
                        if (data?.erro) {
                            showNotification('Não foi possível carregar o endereço para o CEP informado', 'error');
                            setCliente({...cliente, "endereco": {"cep" : valor, "bairro": "", "rua": "", "cidade": "", "uf": ""}});
                        } else {
                            setCliente({...cliente, "endereco": {"cep" : valor, "bairro": data?.bairro, "rua": data?.logradouro, "cidade": data?.localidade, "uf": data?.uf}})
                            showNotification('CEP carregado com sucesso', 'success');
                        }
                    })
                    .catch(error => {
                        showNotification('Não foi possível carregar o endereço para o CEP informado', 'error');
                        setCliente({...cliente, "endereco": {"cep" : valor, "bairro": "", "rua": "", "cidade": "", "uf": ""}});
                    });
        } else if(cliente?.endereco) {
            setCliente({...cliente, "cep" : valor, "endereco": {"cep" : valor, "bairro": "", "rua": "", "cidade": "", "uf": ""}});
        }
    };

    return (
        <div className="form-container">

            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                top: "0", // Aqui muda pra aparecer no topo
                right: "30px",
                maxHeight: "100vh",
                zIndex: 9999 
            }}></div>

            <div className="header-container-form">
                <h1 style={{ color: '#5E5E5E' }}>Cliente</h1>
                <Button variant="text" onClick={() => navigate(`/clientes`)} startIcon={(<BackIcon style={{ fontSize: '2rem', fontWeight: 'bold', color:'#0057a3' }}/>)} />
            </div>


            <div className='row'>
                <Input id="documento"
                    value={aplicarMascaraCpfCnpj(cliente?.documento)}
                    parameters={{error:error.documento, width: '20%', label:"Documento*", onChange: (value) => handleInputChange('documento', value)}}/>
                
                <Input id="nome"
                    value={cliente?.nome}
                    parameters={{error:error.nome, width: '45%', label:"Nome*", onChange: (value) => handleInputChange('nome', value)}}/>
                
                <Input id="dataNascimento"
                    value={cliente?.dataNascimento || ""}
                    parameters={{error:error.dataNascimento, width: '18%', type:'date', label:"Data de nascimento", onChange: (value) => handleInputChange('dataNascimento', value)}}/>
              
              <div className="checkbox-group">
                <input type="checkbox" id="ativo" name="ativo" checked={cliente.ativo} onClick={() => cliente.ativo ? setShowInactiveModal(true): handleInputChange('ativo', true)}/>
                <label htmlFor="ativo" className="checkbox-label">Ativo</label>
            </div>
              
              </div>

            <div className='row'>
                <Input id="email"
                        value={cliente?.email}
                        parameters={{error:error.email, width: '35%', label:"E-mail", onChange: (value) => handleInputChange('email', value)}}/>
                    
                
                <InputPhone id="telefone"
                    value={cliente?.telefone || ''}
                    parameters={{error:error.telefone, width: '20%', label:"Telefone Principal*", onChange: (value) => handleInputChange('telefone', value)}}/>
                
                <InputPhone id="telefoneSecundario"
                    value={cliente?.telefoneSecundario}
                    parameters={{error:error.telefoneSecundario, width: '20%', label:"Telefone secundário", onChange: (value) => handleInputChange('telefoneSecundario', value)}}/>
                
                <Input id="ramoAtividade"
                    value={cliente?.ramoAtividade}
                    parameters={{error:error.ramoAtividade, width: '15%', label:"Área de atuação*", onChange: (value) => handleInputChange('ramoAtividade', value)}}/>
            </div>

            <div className='row'>
                <Input id="cep"
                    value={cliente?.endereco?.cep}
                    parameters={{error:error.endereco || error['endereco.cep'], width: '15%', label:"CEP*", onChange: (value) => handleCEP(value)}}/>
                
                <Input id="numero"
                    value={cliente?.endereco?.numero}
                    parameters={{error:error.endereco || error['endereco.numero'], width: '5%', label:"Número*", onChange: (value) => handleInputChange('endereco.numero', value)}}/>
                
                <Input id="uf"
                    value={cliente?.endereco?.uf}
                    parameters={{error:error.endereco || error['endereco.uf'], width: '5%', label:"UF*", onChange: (value) => handleInputChange('endereco.uf', value)}}/>
                
                <Input id="cidade"
                    value={cliente?.endereco?.cidade}
                    parameters={{error:error.endereco || error['endereco.cidade'], width: '20%', label:"Cidade*", onChange: (value) => handleInputChange('endereco.cidade', value)}}/>
                
                <Input id="bairro"
                    value={cliente?.endereco?.bairro}
                    parameters={{error:error.endereco || error['endereco.bairro'], width: '20%', label:"Bairro*", onChange: (value) => handleInputChange('endereco.bairro', value)}}/>
                
                <Input id="rua"
                    value={cliente?.endereco?.rua}
                    parameters={{error:error.endereco || error['endereco.rua'], width: '25%', label:"Logradouro*", onChange: (value) => handleInputChange('endereco.rua', value)}}/>
            </div>

            <div className='row'>
                <Input id="usuarioUltimaAlteracao"
                    value={cliente?.usuarioUltimaAlteracao || ""}
                    parameters={{error:error.usuarioUltimaAlteracao, width: '15%', label:"Última alteração", disabled:true, onChange: (value) => handleInputChange('usuarioUltimaAlteracao', value)}}/>
              
            

            {showInactiveModal &&<CheckboxComConfirmacao parameters={{
                message: "Atenção: Ao inativar o cliente, ele não poderá mais ser selecionado na aba de Contratos. Tem certeza de que deseja continuar?",
                confirm: () => {
                    setShowInactiveModal(false);
                    handleInputChange('ativo', false);
                }, 
                cancel: () => {
                    setShowInactiveModal(false);
                }}}>
                </CheckboxComConfirmacao>}
              
              </div>
            
            {(
                <button onClick={() => salvarCliente()} className="add-button">
                    Salvar cliente
                </button>
            )}
        </div>
    );
}

export default ClienteForm;
